// removed by extract-text-webpack-plugin
module.exports = {"setDateButton":"_1Z6z-","picker":"_2KABg","column":"_2SxJd","numberInput":"DIt5r","noBottomMargin":"_3fqMj","todayPlaceholder":"_2cSr4"};


//////////////////
// WEBPACK FOOTER
// ./src/components/search/DatePicker.css
// module id = 843
// module chunks = 0